<!--  -->
<template>
  <div class="BottomNav">
    <div class="Bootom_main">
      <div class="Bootom_logo">
        <div class="logo_wrap">
          <router-link to="/">
            <div class="logo_box">
              <img class="imgControl" src="../assets/bottom/BootomLogo.png" />
            </div>
            <span>{{ moli }}</span>
          </router-link>
        </div>
      </div>

      <div class="Bootom_contact">
        <h1>{{ contact }}</h1>
        <div class="contact_us">
          <div class="contact_email">
            <img src="../assets/bottom/BootomEmail.png" />
            <span>{{ Email }}</span>
          </div>
          <div class="contact_phone">
            <img src="../assets/bottom/BootomPhone.png" />
            <span>{{ Phone }}</span>
          </div>
          <div class="contact_site">
            <img src="../assets/bottom/BootomSite.png" />
            <span>{{ Site }}</span>
          </div>
        </div>
      </div>

      <div class="Bootom_link">
        <h1>{{ Link }}</h1>
        <div class="Link_list">
          <ul>
            <li v-for="(item, index) in NavList.slice(1)" :key="index">
              <router-link :to="item.url">
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="Bootom_market">
        <h1>{{ market }}</h1>
        <div class="market_box">
          <div
            class="market_logo"
            v-for="(item, index) in marketList"
            :key="index"
          >
            <img class="imgControl" :src="item.src" />
          </div>
        </div>
      </div>

      <div class="Bootom_community">
        <div class="community_jump">
          <a
            href="https://www.facebook.com/konjacnoodle2014"
            target="view_window"
          >
            <img src="../assets/bottom/1.png"
          /></a>
          <a
            href="https://www.linkedin.com/company/28718034/admin/"
            target="view_window"
          >
            <img src="../assets/bottom/2.png"
          /></a>
          <a
            href="https://studio.youtube.com/channel/UCU9di3rXCcXRx3jMwEviNdg"
            target="view_window"
          >
            <img src="../assets/bottom/3.png"
          /></a>
        </div>
        <h1>{{ community }}</h1>
        <input type="text" v-model="selfEmail" :placeholder="tishi" />
        <div class="submit" @click="onSubmit()">
          <span>{{ submit }}</span>
        </div>
      </div>
    </div>
    <div class="Bootom_copyright">
      <span>{{ copyright }}</span>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      moli: "",

      contact: "",
      Email: "",
      Phone: "",
      Site: "",

      Link: "",
      NavList: [],

      market: "",
      marketList: [
        {
          src: require("../assets/bottom/4.png"),
          url: "/",
        },
        {
          src: require("../assets/bottom/5.png"),
          url: "/",
        },
        {
          src: require("../assets/bottom/6.png"),
          url: "/",
        },
        {
          src: require("../assets/bottom/7.png"),
          url: "/",
        },
        {
          src: require("../assets/bottom/8.png"),
          url: "/",
        },
        {
          src: require("../assets/bottom/9.png"),
          url: "/",
        },
      ],

      community: "",
      selfEmail: "",
      tishi: "",
      submit: "",

      copyright: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onSubmit() {
      //   跳转到联系我们界面
      if (this.selfEmail != "") {
        this.$router.push({ path: "/ContactUs?email=" + this.selfEmail });
      } else {
        this.tishi = "Please enter email address";
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var that = this;
    // 获取界面配置项
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "get_config",
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          that.Email = obj.data[6].value;
          that.copyright = obj.data[15].value;
          if (obj.lang) {
            that.Phone = obj.data[13].value;
            that.Site = obj.data[11].value;
          } else {
            that.Phone = obj.data[12].value;
            that.Site = obj.data[5].value;
          }
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
    // 获取界面翻译项
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "get_fanyi",
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          that.moli = obj.data["moli"];
          that.contact = obj.data["lxwm"];
          that.Link = obj.data["kslj"];
          that.market = obj.data["wmdcs"];
          that.community = obj.data["jrwm"];
          that.submit = obj.data["jx"];
          that.tishi = obj.data["yxdz"];
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
    // 获取顶部导航栏信息
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "get_nav",
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          if (obj.data) {
            $.each(obj.data, function (i, k) {
              var danghang = {
                title: k.title,
                url: k.url,
              };
              that.NavList.push(danghang);
            });
          }
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.BottomNav {
  width: 100%;
  height: 416px;
  background: #39404a;
  .Bootom_main {
    width: 100%;
    padding: 46px 9.25rem 0;
    height: 335px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: space-between;
    h1 {
      font-size: 1rem;
      font-weight: bold;
      color: #ffffff;
      line-height: 1.5;
    }
    .Bootom_logo {
      display: flex;
      align-items: center;
      .logo_wrap {
        .logo_box {
          width: 2.7rem;
          height: 2.7rem;
          margin: 0 auto;
        }
        span {
          display: block;
          text-align: center;
          font-size: 1rem;
          font-weight: bold;
          color: #ffffff;
          line-height: 1.5;
          margin-top: 20px;
        }
      }
    }

    .Bootom_contact {
      width: 12rem;
      .contact_us {
        margin-top: 42px;
        span {
          font-size: 0.8rem;
          font-weight: 400;
          color: #ffffff;
          line-height: 1.5;
          margin-left: 14px;
        }
        .contact_email {
          display: flex;
          align-items: center;
        }
        .contact_phone {
          display: flex;
          align-items: center;
          margin-top: 30px;
        }
        .contact_site {
          display: flex;
          align-items: center;
          margin-top: 30px;
        }
      }
    }

    .Bootom_link {
      .Link_list {
        margin-top: 42px;
        a {
          font-size: 0.8rem;
          font-weight: 400;
          color: #ffffff;
          transition: 0.3s;
        }
        li:nth-child(n + 2) {
          margin-top: 8px;
        }
        a:hover {
          color: #5fbb68;
        }
      }
    }

    .Bootom_market {
      width: 17rem;
      h1 {
        text-align: center;
        color: #fcce4b;
      }
      .market_box {
        margin-top: 2.1rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .market_logo {
          width: 48%;
          height: auto;
        }
        .market_logo:nth-child(n + 3) {
          margin-top: 20px;
        }
      }
    }

    .Bootom_community {
      .community_jump {
        display: flex;
        justify-content: center;
        a {
          margin: 0 4px;
          width: 30px;
          height: auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      h1 {
        margin-top: 28px;
        text-align: center;
      }
      input {
        border: none;
        width: 100%;
        background-color: rgba(255, 255, 255, 0);
        border-bottom: 1px solid #ffffff;
        padding: 0 0 8px 15px;
        margin-top: 50px;
        color: #fff;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        font-style: italic;
        font-size: 0.8rem;
        font-weight: bold;
        color: #ffffff;
        line-height: 1.5;
        opacity: 0.6;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        font-style: italic;
        font-size: 0.8rem;
        font-weight: bold;
        color: #ffffff;
        line-height: 1.5;
        opacity: 0.6;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        font-style: italic;
        font-size: 0.8rem;
        font-weight: bold;
        color: #ffffff;
        line-height: 1.5;
        opacity: 0.6;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        font-style: italic;
        font-size: 0.8rem;
        font-weight: bold;
        color: #ffffff;
        line-height: 1.5;
        opacity: 0.6;
      }
      .submit {
        width: 18.3rem;
        height: 2.4rem;
        background: #5fbb68;
        border-radius: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 44px;
        cursor: pointer;
        span {
          font-size: 0.9rem;
          font-weight: bold;
          color: #39404a;
        }
      }
    }
  }

  .Bootom_copyright {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.8rem;
      font-weight: 300;
      color: #ffffff;
      line-height: 1.5;
    }
  }
}
@media screen and (max-width: 1700px) {
  .BottomNav {
    height: auto;
    .Bootom_main {
      padding: 46px 6rem 0;
    }
  }
}
@media screen and (max-width: 1200px) {
  .BottomNav {
    height: auto;
    .Bootom_main {
      padding: 20px 10px;
      flex-direction: column;
      height: auto;
      .Bootom_logo {
        display: none;
      }
      .Bootom_contact {
        display: none;
      }
      .Bootom_link {
        display: none;
      }
      .Bootom_market {
        width: 100%;
        .market_box {
          .market_logo {
            height: auto;
          }
        }
      }
      .Bootom_community {
        margin-top: 20px;
        .submit {
          width: 100%;
        }
        h1 {
          margin-top: 15px;
        }
      }
    }
    .Bootom_copyright {
      span {
        padding: 0 10px;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BootomNav.vue